/**
 * Vertragsmanagement API
 * REST-Api für das Conergos Vertragsmanagement Tool.
 *
 * OpenAPI spec version: 0.1.0
 * Contact: marius.junak@scorpius-forge.de
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ChronoUnitEnum } from '@bo-client/shared/constants/enums';
import { TypedForm } from '@bo-client/shared/forms/generic-forms/typedForm.type';

export interface DocumentDto {
  cokDocId?: string;
  displayName?: string;
  fileName?: string;
  id?: number;
  roles?: Array<DocumentDto.RolesEnum>;
  url?: string;
  tag?: string;
}

export namespace DocumentDto {
  export type RolesEnum = 'Lieferant' | 'Netznutzer' | 'Bilanzkreisverantwortlicher' | 'Messstellenbetreiber';
  export const RolesEnum = {
    Lieferant: 'Lieferant' as RolesEnum,
    Netznutzer: 'Netznutzer' as RolesEnum,
    Bilanzkreisverantwortlicher: 'Bilanzkreisverantwortlicher' as RolesEnum,
    Messstellenbetreiber: 'Messstellenbetreiber' as RolesEnum
  };
}

export class DocumentDtoModel {
  cokDocId?: string = '';
  displayName?: string = '';
  fileName?: string = '';
  id?: number;
  roles?: Array<DocumentDto.RolesEnum>;
  url?: string = '';
  tag?: string = '';
  displayToCustomer?: Boolean;
  transfered?: Boolean;
  relatedToArea?: string;
}

export class AnswerModel {
  id?: number;
  sortPosition?: number;
  required?: boolean;
  common?: boolean;
  networkOperator?: number;
  validated?: boolean;
  docReference?: number;
  docType?: string;
  isAnswered?: string;
  docRenewed?: boolean = false;
  name?: string;
  description?: string;
  comment?: string;
  validFrom?: Date;
  validTo?: Date;
  attachments?: DocumentDtoModel[];
}

export type UploadForm = TypedForm<
  Pick<DocumentDto, 'id' | 'cokDocId' | 'displayName' | 'fileName' | 'url' | 'tag'>
>;
